import { useAuthenticatedApiClient } from '@guiker/react-framework'
import { AuthenticatedApiClient } from '@guiker/tenant-preference-shared'

export const useAuthenticatedTenantPreferenceApiClient = useAuthenticatedApiClient(AuthenticatedApiClient)
